import MainLayout from '@/components/layout/MainLayout.vue';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Select2Multiple from 'v-select2-multiple-component';
import axios from "axios";
import store from "@/store";
import "vue-loading-overlay/dist/vue-loading.css";
import { required, maxLength } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import CONFIG from "@/assets/js/config.js";
import pdfIcon from '@/assets/images/pdf.png';
import docIcon from '@/assets/images/icon-doc.png';
import pptIcon from '@/assets/images/icon-ppt.png';

export default {
  name: "editAssignment",

  components: {
    MainLayout,
    DatePicker,
    Select2Multiple
  },

  data() {
    return {
      updateAssignment: {},
      submitted: false,
      disabled: false,
      submit_permission: false,
      date_invalid_error: false,
      files: [],
      oldDate: null,
      CONFIG,
      pdfIcon,
      docIcon,
      pptIcon,
      new_files: [],
      existing_files: [],
    };
  },

  validations: {
    updateAssignment: {
      title: {
        required,
        maxLength: maxLength(100)
      },
      description: {
        maxLength: maxLength(5000)
      },
      from_date: {
        required
      },
      to_date: {
        required
      }
    }
  },

  computed: {
    ...mapGetters(["teacherId", "studentId", "userType"]),
  },

  methods: {
    date_check() {
      var from_date = this.updateAssignment.from_date;
      var to_date = this.updateAssignment.to_date;
      if (to_date != '' && to_date < from_date) {
        this.date_invalid_error = true;
      } else {
        this.date_invalid_error = false;
      }
    },

    notBeforeDate(date) {
      const today = new Date().setHours(0, 0, 0, 0);
      if (!this.oldDate) return date < today;
      const oldDate = new Date(this.oldDate).setHours(0, 0, 0, 0);

      if (oldDate < today) {
        return date < oldDate;
      } else {
        return date < today;
      }
    },

    getDetail() {
      axios.get(`my/assignment/detail/${this.$route.params.id}`)
        .then(res => {
          this.updateAssignment = res.data;
          this.updateAssignment.deleted_exist_file = [];
          this.oldDate = this.updateAssignment.from_date;
          this.existing_files = this.updateAssignment.assignment_files;
          this.existing_files.forEach((file, index) => {
            this.existing_files[index].type = file.name.split('.')[1];
          });
          if (this.updateAssignment.class_name) {
            this.updateAssignment.class_name = `${this.updateAssignment.class_name} (${CONFIG.CLASS_TYPE_LABEL[this.updateAssignment.class_type]})`;
          }
        })
        .catch((error) => {
          if (error.response.status == 404) {
            this.$router.replace({
              name: 'notFound'
            });
          }

          if (error.response.status == 403) {
            this.$router.push({
              name: 'forbidden'
            });
          }

          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log(error);
        });
    },

    submit() {
      if (this.date_invalid_error == false) {
        this.submitted = true;
        this.submit_permission = false;
        if (this.$v.updateAssignment.$invalid) {
          return;
        }
        this.update();
      } else {
        this.submit_permission = true;
      }
    },

    update() {
      this.disabled = true;
      axios.post(`my/assignment/update/${this.$route.params.id}`, this.createRequest())
        .then(res => {
          let message = null;
          if (res.status == 200) {
            this.$router.push({
              name: "manageAssignment"
            });
            message = "လုပ်ဆောင်မှု အောင်မြင်ပါသည်။";
          } else {
            this.disabled = false;
            this.$router.push({
              name: "editAssignment"
            });
            message = "လုပ်ဆောင်မှု မအောင်မြင်ပါ။";
          }

          this.$notification.success(message, {
            timer: 3,
            position: "bottomCenter"
          });
        }).catch(error => {
          this.disabled = false;
          if (error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
            return;
          }

          if (error.response && error.response.status == 422) {
            const respData = error.response.data;
            const isStudentAnswerExists = respData === 'Student answer exists!'
              || (respData && respData.message === 'Student answer exists!');
            if (isStudentAnswerExists) {
              this.$notification.error("ပြင်ဆင်၍ မရပါ! အဖြေများ ရှိနေသည်။", {
                timer: 4,
                position: "bottomCenter"
              });
              this.$router.push({
                name: "manageAssignment"
              });
              return;
            }
          }

          this.$notification.error("လုပ်ဆောင်မှု မအောင်မြင်ပါ။", {
            timer: 3,
            position: "bottomCenter"
          });
        });
    },

    createRequest() {
      this.updateAssignment.files = this.new_files;
      this.updateAssignment.description = this.updateAssignment.description ?? '';

      let formData = new FormData();
      for (let key in this.updateAssignment) {
        var data = this.updateAssignment[key];
        if (Array.isArray(data)) {
          if (key == "class_ids" && data.find(id => id == 0)) {
            this.classes.forEach(item => {
              if (item.id) formData.append(`${key}[]`, item.id);
            });
          } else if (key == 'files') {
            data.forEach((item, index) => {
              formData.append(`${key}[${index}]`, item.file);
            });
          } else {
            data.forEach(item => {
              formData.append(`${key}[]`, item);
            });
          }
        } else {
          formData.append(key, data);
        }
      }
      return formData;
    },

    notificationCount() {
      var id = null;
      var type = this.userType;
      if (this.teacherId) {
        id = this.teacherId;
      }
      if (this.studentId) {
        id = this.studentId;
      }
      axios.get("my/notification/count", {
        params: {
          id: id,
          type: type
        }
      })
        .then(response => {
          store.commit("setNotificationCount", response.data);
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log(error, "error");
        });
    },

    chooseFiles(id) {
      document.getElementById(id).click();
    },

    onFileChange(e) {
      var selectedFiles = e.target.files;
      if (!selectedFiles || !selectedFiles.length) return;

      for (let i = 0; i < selectedFiles.length; i++) {
        let file = selectedFiles[i];
        let fileExtension = file.name.split('.').pop().toLowerCase();

        if (!CONFIG.ASSIGNMENT.ALLOWED_FILE_TYPES.includes(file.type) || fileExtension === 'jfif') {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Type, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }
        if (file.size > CONFIG.ASSIGNMENT.MAX_FILE_SIZE) {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Max_Size, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }
        if ((this.new_files.length + this.existing_files.length) >= CONFIG.ASSIGNMENT.MAX_FILE_COUNT) {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Max_Count, {
            timer: 3,
            position: "bottomCenter",
          });
          break;
        }

        const filenameLower = file.name.toLowerCase();
        const existsOld = this.existing_files.some(
          f => (f.name || '').toLowerCase() === filenameLower
        );
        const existsNew = this.new_files.some(
          f => (f.name || '').toLowerCase() === filenameLower
        );

        if (existsOld || existsNew) {
          this.$notification.error(`"${file.name}" is already added.`, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }

        const fileObj = {
          file: file,
          name: file.name,
          type: file.type,
          data: null
        };
        this.new_files.push(fileObj);

        if (file.type.match(/image/i)) {
          const reader = new FileReader();
          reader.onload = () => {
            fileObj.data = reader.result;
          };
          reader.readAsDataURL(file);
        }
      }

      const inputEl = document.getElementById('answer-file');
      if (inputEl) inputEl.value = null;
    },

    confirmRemoveFile(i, oldFileId) {
      const message = 'ဤ File ကို ဖျက်ရန် သေချာပါသလား?';
      if (window.confirm(message)) {
        this.removeFile(i, oldFileId);
      }
    },

    removeFile(i, oldFileId) {
      if (oldFileId) {
        this.updateAssignment.deleted_exist_file.push(oldFileId);
        this.existing_files.splice(i, 1);
      } else {
        this.new_files.splice(i, 1);
        const inputEl = document.getElementById('answer-file');
        if (inputEl) inputEl.value = null;
      }
    },
  },

  mounted() {
    this.getDetail();
    this.notificationCount();
  },
}
